// Convert unknown value types into a safe, comparable clipboard string.
function toTrimmedString(value) {
  if (typeof value === "string") {
    return value.trim()
  }

  return `${value || ""}`.trim()
}

// Stop and clear any pending feedback reset timer.
export function clearCopyFeedbackTimer(timerRef) {
  if (timerRef?.current) {
    window.clearTimeout(timerRef.current)
    timerRef.current = null
  }
}

// Copy a value to clipboard and temporarily toggle a UI feedback state
// (for example, a "copied" visual indicator).
export async function copyWithFeedback({
  value,
  invalidValues = [],
  setFeedbackState,
  feedbackValue,
  resetValue,
  timerRef,
  delayMs = 1200,
  errorMessage = "Failed to copy value",
}) {
  const textToCopy = toTrimmedString(value)

  // Skip empty/placeholder values that should not be copied.
  if (!textToCopy || invalidValues.includes(textToCopy)) {
    return false
  }

  try {
    await navigator.clipboard.writeText(textToCopy)
    setFeedbackState(feedbackValue)

    // Reset previous timer so rapid clicks always use the latest delay window.
    clearCopyFeedbackTimer(timerRef)
    timerRef.current = window.setTimeout(() => {
      setFeedbackState(resetValue)
      timerRef.current = null
    }, delayMs)

    return true
  } catch (err) {
    console.error(errorMessage, err)
    return false
  }
}
